import type { Relationship } from '@customerio/hydra-ui-api';
import { customerDisplay } from '@/services/db/customer/display';
import type { Customer } from '@/services/db/customer/entity';
import { generatePath } from '@/services/router/generate-path';
import { relationshipCustomer, relationshipKey } from './relationship-customer';
import type { RelationshipRowModel } from './relationship-row';

type BuildRelationshipRowsArgs = {
  relationships: Relationship[];
  customers: Customer[];
  cioObjectId: string;
  workspaceId: number;
  personSingular: string;
  selectedKeys: ReadonlySet<string>;
};

export function buildRelationshipRows(args: BuildRelationshipRowsArgs): RelationshipRowModel[] {
  const { relationships, customers, cioObjectId, workspaceId, personSingular, selectedKeys } = args;
  const customersByCioId = new Map(customers.map((customer) => [customer.internal_id, customer]));

  return relationships.map((relationship, index) => {
    const customer = relationshipCustomer(relationship, cioObjectId, customersByCioId);
    const key = relationshipKey(relationship);

    return {
      key,
      relationship,
      index,
      personName: customer == null ? undefined : customerDisplay(customer, personSingular),
      personHref:
        customer == null
          ? undefined
          : // The person profile is still served by the embedded Ember app.
            generatePath('/workspaces/:workspaceId/journeys/people/:personId', {
              workspaceId,
              personId: customer.internal_id,
            }),
      isSelected: selectedKeys.has(key),
    };
  });
}
